import React from 'react';

// Numbers the legend of each array item by its place in the form: "2" for the
// second item of a list, "2.3" for the third item of a list inside it.
//
// CustomArrayFieldTemplate sets the context around each item, extending the
// number it sits under. RowAwareObjectFieldTemplate shows the number when the
// object is that item (`isItem`), then clears `isItem` for what it renders, so
// objects nested in the item keep their plain titles while lists nested in it
// carry the number on.
export type ItemNumbering = { number: string | null; isItem: boolean };
export const ItemNumberingContext = React.createContext<ItemNumbering>({
  number: null,
  isItem: false,
});

export const childItemNumber = (parent: string | null, index: number) =>
  parent ? `${parent}.${index + 1}` : `${index + 1}`;
